import { fetchAPI } from '@/lib/api';

/** 로그인 없이 보는 약관·처리방침의 현재 판. 서버가 이용자 대상 정책만 내준다. */
export interface PublicPolicy {
  code: string;
  title: string;
  version: number;
  /** 발행일(YYYY-MM-DD) */
  publishedAt: string;
  content: string;
}

export type PublicPolicyCode = 'privacy_policy' | 'terms_of_service';

export async function getPublicPolicy(code: PublicPolicyCode): Promise<PublicPolicy> {
  return fetchAPI(`/api/public/policies/${code}`);
}
